import { useHover } from "@netapp/bxp-design-system-react";
import classNames from "classnames";
import { useLayoutEffect, useRef } from "react";
import ReactDom from "react-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { allMenus as i18nNamespace } from "../../../../../i18n/namespace";
import { ReactComponent as FavouriteSelected } from "../../FavouriteSelected.svg";
import { ReactComponent as FavouriteUnselected } from "../../FavouriteUnselected.svg";
import leftNavStyles from "./CategoriesNav.module.scss";
import { ReactComponent as CategoryMenuFavouriteSelected } from "./CategoryMenuFavouriteSelected.svg";
import { ReactComponent as CategoryMenuFavouriteUnselected } from "./CategoryMenuFavouriteUnselected.svg";

const FavoriteIcons = ({ isHovered, isFavourited, isServiceActive = false }) => {
    if (isServiceActive) {
        return isFavourited ? <FavouriteSelected /> : (isHovered && <FavouriteUnselected />);
    }
    return isFavourited ? <CategoryMenuFavouriteSelected /> : (isHovered && <CategoryMenuFavouriteUnselected />);
}

const ServiceCard = ({ service, onCategoryMenuItemClicked, selectedService }) => {
    const toggleFavourite = (service, isFavourited) => {
        dispatch({
            type: isFavourited ? "MENU:UNSET-FAVOURITE" : "MENU:SET-FAVOURITE",
            payload: {
                serviceId: service.key
            }
        })
    }

    const dispatch = useDispatch();
    const { t } = useTranslation(i18nNamespace);
    const favouritesByKey = useSelector(state => state.menu.favourites.byKey);
    const isFavourited = favouritesByKey[service.key];
    const toggleFavLabel = t("toggle_favorite");
    const { hoverParentProps, isHovered } = useHover();
    const isServiceActive = service?.name === selectedService?.name;

    return (
        <div key={service.key} className={classNames(leftNavStyles['sub-tab-container'], { [leftNavStyles['sub-tab-container-active']]: isServiceActive })} {...hoverParentProps}>
            <div style={{ minWidth: "16px" }}>
                <button style={{ marginTop: "4px" }} onClick={() => toggleFavourite(service, isFavourited)} aria-label={toggleFavLabel}>
                    <FavoriteIcons isHovered={isHovered} isFavourited={isFavourited} isServiceActive={isServiceActive} />
                </button>
            </div>
            <NavLink
                to={service.to}
                data-nav={service.key}
                className={leftNavStyles['sub-tab']}
                activeClassName={leftNavStyles['sub-tab-active']}
                onClick={() => onCategoryMenuItemClicked()}
            >
                {t(service.name)}
                <span className={leftNavStyles['sub-tab-description']}>{service.description ? t(service.description) : t("manage_storage_environment")}</span>
            </NavLink>
        </div>
    );
}

const CategoryServices = ({ services, onCategoryMenuItemClicked, selectedService }) => {
    return services.map((service) => {
        return (
            <ServiceCard
                service={service}
                onCategoryMenuItemClicked={onCategoryMenuItemClicked}
                selectedService={selectedService}
            />
        );
    });
}

const CategoryMenu = ({ isAnimationFinished, services, onCategoryMenuItemClicked, selectedService }) => {
    const refParent = useRef();
    const refChild = useRef();

    useLayoutEffect(() => {
        refChild.current.style.top = `75px`;
        refChild.current.style.left = `228px`;
        refChild.current.style.zIndex = 2147483647;

    }, [isAnimationFinished]);

    return <div ref={refParent}>
        {ReactDom.createPortal(<div ref={refChild} className={leftNavStyles['sub-tabs-container']}>
            <CategoryServices services={services} onCategoryMenuItemClicked={onCategoryMenuItemClicked} selectedService={selectedService} />
        </div>, document.body)}
    </div>
};

export default CategoryMenu;